import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CardModule } from '../card/card.module';
import { BarGraphComponent } from './bar-graph/bar-graph.component';
import { ProgressBarColorDirective } from './horizontal-bar-graph-color.directive';
import { HorizontalBarGraphComponent } from './horizontal-bar-graph.component';

@NgModule({
  declarations: [
    BarGraphComponent,
    HorizontalBarGraphComponent,
    ProgressBarColorDirective,
  ],
  imports: [CommonModule, CardModule, MatProgressBarModule],
  exports: [BarGraphComponent, HorizontalBarGraphComponent],
})
export class HorizontalBarGraphModule {}
